import * as React from 'react';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuthContext } from '@web/api/src';

// const ROLES = ['admin', 'farmer'] as const;

// type Role = (typeof ROLES)[number];

export function UserAuthGuard() {
  const auth = useAuthContext();
  const [isAllowed] = useState(true);
  const [loading] = useState(false);
  const location = useLocation();

  const checkUser = () => {
    if (!auth.jwt) {
      auth.login(location.pathname);
    }

    // TODO: handle check user role logic here;
    // if (TODO) {
    //   setIsAllowed(true);
    //   setLoading(false);
    // }
    // else {
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    checkUser();
  });

  if (!loading && isAllowed) {
    return <>{<Outlet />}</>;
  } else {
    return <>{<div />}</>;
  }
}
